import React, {FC} from 'react';

import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {PermissionDropdownItem, PermissionDropdownItemProps} from './permissionDropdownItem';

/*
 * Props.
 */

export interface PermissionSimpleDropdownItemProps extends PermissionDropdownItemProps {}

/*
 * Component.
 */

export const PermissionSimpleDropdownItem: FC<PermissionSimpleDropdownItemProps> = ({children, ...props}) => (
  <PermissionDropdownItem {...props}>
    <DropdownItemContent isChecked={props.isChecked}>{children}</DropdownItemContent>
  </PermissionDropdownItem>
);
